
import { Component, Vue } from 'vue-property-decorator'

import { DealRedemption } from '@/types/Deal'
import dealModule from '@/store/deal'

@Component({
  name: 'RedemptionsList'
})
class RedemptionsList extends Vue {
  private get redemptions(): DealRedemption[] {
    return dealModule.redemptions
  }

  private async created() {
    Vue.filter('formattedDate', this.formattedDate)

    await dealModule.fetchRedemptions()
  }

  private formattedDate(rawDate: string) {
    const date = new Date(rawDate)

    const time = date.toLocaleTimeString('de-DE', {
      hour: '2-digit',
      minute: '2-digit'
    })

    return `${date.toLocaleDateString('de-DE')} um ${time}`
  }

  private async review(redemption: DealRedemption, approved: boolean) {
    await dealModule.updateRedemption({ redemption, approved })
    await dealModule.fetchRedemptions()
  }
}

export default RedemptionsList
